import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "../../stargate/express/server";

export const trpc = createTRPCReact<AppRouter>();
